import { PageMeta } from 'types/Pages'

export const PageMetaSetting: PageMeta = {
  location: '/clients/:id',
  title: 'Editar cliente',
  endpoint: '/app/person',
  breadcrumbs: [{ label: '', location: '' }],
}
